// extracted by mini-css-extract-plugin
module.exports =  {"section-field":"section-field--SxGA3","sectionField":"section-field--SxGA3"};